import { render, staticRenderFns } from "./BindOld.vue?vue&type=template&id=76b8248c&scoped=true"
import script from "./BindOld.vue?vue&type=script&lang=js"
export * from "./BindOld.vue?vue&type=script&lang=js"
import style0 from "./BindOld.vue?vue&type=style&index=0&id=76b8248c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76b8248c",
  null
  
)

export default component.exports